export { default } from 'rde-view-common/middleware/auth';
